<template>
	<BaseModal :data-context="mixpanelDataContext" @modal-close="close">
		<div class="module">
			<div class="module-header text-align-center">
				<div class="modal-close-parent heading-5">
					<span>{{ disclaimerTitle }}</span>
					<BaseButtonIconOnly class="modal-close" :unstyled="true" icon="close" @click="close" />
				</div>
			</div>
			<div :class="['module-section', { 'text-align-center': centeredContent }]">
				<div v-if="image" class="col-8-md block-align-center-md">
					<div class="position-relative">
						<img :src="image" alt="" role="presentation" />
					</div>
				</div>
				<p v-for="(paragraph, id) in content" :key="id" v-html="paragraph"></p>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
interface Props {
	title?: string | undefined;
	content: Array<string>;
	image?: string | undefined;
	centeredContent?: boolean;
	dataContext?: string | undefined;
}

interface Emits {
	(e: 'modal-close'): void;
}

const props = withDefaults(defineProps<Props>(), {
	title: undefined,
	image: undefined,
	centeredContent: true,
	dataContext: undefined
});

const emit = defineEmits<Emits>();

const mixpanelDataContext = computed((): string => {
	return props.dataContext ?? props.title ?? 'DisclaimerSimpleModal';
});

const disclaimerTitle = computed((): string => {
	return props.title ? props.title : 'About this section';
});

function close(): void {
	emit('modal-close');
}
</script>
